import { isDeployedProduction, tawkToId } from './config'

export function attachTawkTo() {
  if (!tawkToId || !isDeployedProduction || window.__PRERENDER_INJECTED) return

  window.Tawk_API = window.Tawk_API || {}
  window.Tawk_LoadStart = new Date()

  const [firstScript] = document.getElementsByTagName('script')
  const script = document.createElement('script')

  script.async = true
  script.src = `https://embed.tawk.to/${tawkToId}`
  script.charset = 'UTF-8'
  script.setAttribute('crossorigin', '*')

  firstScript.parentNode.insertBefore(script, firstScript)
}
